import { Box, CircularProgress, TextField } from '@material-ui/core'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Links from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import LanguageIcon from '@material-ui/icons/Language'
import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'
import { TFunction } from 'i18next'
import { parse } from 'query-string'
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { withTranslation } from 'react-i18next'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { errorToast } from '../../../../utils/errToast'
import { setItemToLocalStorage } from '../../../../utils/setLocalStorage'
import { useAppState } from '../../../appState'
import editIcon from '../../../assets/images/edit-info.svg'
import uploadIconHover from '../../../assets/images/upload-hover.svg'
import uploadIcon from '../../../assets/images/upload.svg'
import axios from '../../../axios'
import {
  COLORS,
  ENDPOINTS,
  ProfileSocialLink,
  ROUTES,
  baseURL,
  formatUrlWithProtocol,
  getProfileSocialPlatform,
  parseJsonField,
  parseProfileLinksFromExternalLinks,
} from '../../../constants'
import CHRUploadAvatar from '../../AmplifyUpload'
import CHRButton from '../../button'
import ContentContainer from '../../contentContainer'
import AddFromInstagramModal from '../addFromInstagramModal'
import ConnectInstagramModal from '../connectInstagramModal'
import CreateNewFolderModal from '../createNewFolderModal'
import ManageProfileModal, {
  ProfileModalSubmitData,
} from '../manageProfileModal'
import SBSort from '../sbSort'
import ShareShoppingBoardModal from '../shareShoppingBoardModal'
import SwitchAccountsModal from '../swithAccountsModal'
import { styles } from './styles'
import Anchor from '../../anchor'

const getInstagramUrlFromSocialUrls = (socialUrls: unknown) => {
  const parsed = parseJsonField<Record<string, string>>(socialUrls)
  if (!parsed) return ''
  return parsed.instagramUrl || parsed.instagram || ''
}

interface BoardProfileProps {
  t: TFunction
  handleSortChange: any
  options: any
  nonUserOptions: any
  shareUrl: string
  selectedSort: any
  canEdit: boolean
  reloadShopping: any
  shoppingUserProfile: any
  handleSBoardItemsChange: Function
  folderView: boolean
  shoppingBoardItems: any[]
  handleCreateFolder: Function
  searchQuery?: string
  handleSearchQueryChange: (value: string) => void
}

const BoardProfile = ({
  t,
  handleSortChange,
  options,
  nonUserOptions,
  shoppingUserProfile: shoppingUserProfileInit,
  selectedSort,
  canEdit,
  handleSBoardItemsChange,
  folderView = false,
  shoppingBoardItems,
  handleCreateFolder,
  searchQuery = '',
  handleSearchQueryChange,
}: BoardProfileProps) => {
  const classes = styles()

  const { search } = useLocation()
  const { redirectCode } = parse(search)

  const [appState, dispatch] = useAppState()
  const [isModal, setIsModal] = useState(false)
  const [isFolderModal, setIsFolderModal] = useState(false)
  const [isEditingBio, setIsEditingBio] = useState(false)
  const [shortBio, setShortBio] = useState('')
  const [isBioOpen, setIsBioOpen] = useState(false)
  const [isBioOverflowing, setIsBioOverflowing] = useState(false)
  const [blogLink, setBlogLink] = useState('')
  const shortBioInput = useRef(null)
  const bioDisplayRef = useRef<HTMLDivElement | null>(null)
  const [isModalIg, setIsModalIg] = useState(false)
  const [instaModal, setInstaModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isIgPrivate, setIsIgPrivate] = useState()
  const [isFetchingIgPosts, setIsFetchingIgPosts] = useState(true)
  const [igErr, setIgErr] = useState('')
  const [shoppingUserProfile, setShoppingUserProfile] = useState(
    shoppingUserProfileInit
  )
  const isBioToggleBtnVisible = isBioOpen || isBioOverflowing
  const shareUrl = `${process.env.GATSBY_SITE_URL}/s/${shoppingUserProfile.username}`
  const [instagramUrl, setInstagramUrl] = useState(() =>
    getInstagramUrlFromSocialUrls(shoppingUserProfileInit.socialUrls)
  )
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down(1600), { noSsr: true })
  const [igNextProducts, setIgNextProducts] = useState('')
  const [isSwitchModalOpen, setIsSwitchModalOpen] = useState(false)
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false)
  const [profileExternalLinks, setProfileExternalLinks] = useState<
    ProfileSocialLink[]
  >(() =>
    parseProfileLinksFromExternalLinks(shoppingUserProfileInit.externalLinks)
  )

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const closeModal = () => {
    setIsModal(false)
  }

  const closeCreateNewFolderModal = () => {
    setIsFolderModal(false)
  }

  const closeModalIg = () => {
    setIsModalIg(false)
  }

  const addItemToShoppingBoard = () => {
    navigate('/user/share-with-friends')
  }

  const handleCreateShareLinkClick = () => {
    setIsModal(true)
  }

  const handleCreateNewFolderClick = () => {
    setIsFolderModal(true)
  }

  const truncateUserName = (name: string = '') => {
    const maxLength = isTablet ? 10 : 23
    if (name.length > maxLength) {
      return name.slice(0, maxLength) + '...'
    }
    return name
  }

  const onSortChange = (event: any) => {
    handleSortChange(event)
  }

  const focusShortBioInput = () => {
    setIsEditingBio(true)
    shortBioInput.current.focus()
  }
  const updateShortBio = async (shortBio: string) => {
    try {
      if (shoppingUserProfile.shortBio == shortBio) {
        return
      }
      await axios.patch(
        `${baseURL}/${ENDPOINTS.user.replace(':id', appState.userId)}`,
        {
          shortBio: shortBio,
        }
      )

      setShoppingUserProfile(s => ({ ...s, shortBio }))
    } catch (err) {
      errorToast(`couldn't update bio, please try again`)
    }
  }
  const updateProfileFromModal = async ({
    shortBio: updatedShortBio,
    blogLink: updatedBlogLink,
    links,
  }: ProfileModalSubmitData) => {
    const existingExternalLinks =
      parseJsonField<Record<string, unknown>>(
        shoppingUserProfile.externalLinks
      ) || {}

    const externalLinksValue = JSON.stringify({
      ...existingExternalLinks,
      profileLinks: links.map(({ platform, url }) => ({ platform, url })),
    })

    await axios.patch(
      `${baseURL}/${ENDPOINTS.user.replace(':id', appState.userId)}`,
      {
        shortBio: updatedShortBio,
        blogLink: updatedBlogLink,
        externalLinks: externalLinksValue,
      }
    )

    setShortBio(updatedShortBio)
    setBlogLink(updatedBlogLink)
    setProfileExternalLinks(links)
    setShoppingUserProfile(s => ({
      ...s,
      shortBio: updatedShortBio,
      blogLink: updatedBlogLink,
      externalLinks: externalLinksValue,
    }))
  }

  const updateShoppingProfile = (data: any) => {
    setShoppingUserProfile(data)
  }
  useEffect(() => {
    setShoppingUserProfile(shoppingUserProfile)
    setShortBio(shoppingUserProfile?.shortBio || '')
    setBlogLink(shoppingUserProfile?.blogLink || '')
    setProfileExternalLinks(
      parseProfileLinksFromExternalLinks(shoppingUserProfile?.externalLinks)
    )
  }, [
    shoppingUserProfile.shortBio,
    shoppingUserProfile.blogLink,
    shoppingUserProfile.externalLinks,
  ])

  const bioClampClass = !isBioOpen
    ? classes.profileBioClamped
    : classes.profileBioExpanded

  useLayoutEffect(() => {
    const el = bioDisplayRef.current
    if (!el || isEditingBio) {
      setIsBioOverflowing(false)
      return
    }

    const measureOverflow = () => {
      if (isBioOpen) return
      requestAnimationFrame(() => {
        if (!bioDisplayRef.current) return
        setIsBioOverflowing(
          bioDisplayRef.current.scrollHeight >
            bioDisplayRef.current.clientHeight + 1
        )
      })
    }

    measureOverflow()
    window.addEventListener('resize', measureOverflow)
    return () => window.removeEventListener('resize', measureOverflow)
  }, [
    shortBio,
    shoppingUserProfile?.shortBio,
    isBioOpen,
    isEditingBio,
    canEdit,
  ])

  const displayBlogLink = (
    blogLink ||
    shoppingUserProfile?.blogLink ||
    ''
  ).trim()
  const rawShortBio = canEdit ? shortBio : shoppingUserProfile?.shortBio || ''
  const displayShortBio = rawShortBio && !rawShortBio.trim() ? '' : rawShortBio
  const blogPlatform = getProfileSocialPlatform('website')
  const hasProfileSocialIcons =
    profileExternalLinks.length > 0 || Boolean(displayBlogLink)

  const renderProfileSocialIcon = (
    key: string,
    url: string,
    label: string,
    iconSrc?: string
  ) => {
    const trimmedUrl = url.trim()
    if (!trimmedUrl) return null

    return (
      <Anchor
        key={key}
        className={classes.profileSocialLink}
        href={formatUrlWithProtocol(trimmedUrl)}
        title={label}
        aria-label={label}
      >
        {iconSrc ? (
          <img src={iconSrc} alt="" className={classes.profileSocialIconImg} />
        ) : (
          <LanguageIcon
            className={classes.profileSocialIconFallback}
            aria-hidden
          />
        )}
      </Anchor>
    )
  }

  const attachSbIdsToIgPosts = (items: any) => {
    const shoppingBoardItemsIds = new Map()

    shoppingBoardItems.forEach(e => {
      if (e.type === 'instagram') {
        shoppingBoardItemsIds.set(e.data.post_id, e.id)
      }
    })

    return items.map((item: any) => {
      if (shoppingBoardItemsIds.has(item.id)) {
        return { ...item, shoppingBoardId: shoppingBoardItemsIds.get(item.id) }
      } else {
        return item
      }
    })
  }

  const handleGetIgPosts = async (url: string) => {
    // had to use fetch api here since axios can't bypassing cors errors that is thrown here in case of error
    const IG_RATE_LIMIT_EXCEEDED_ERR_CODE = 4
    const apiCall = () => fetch(url, { mode: 'cors' })
    let attempts = 3
    let resBody

    while (attempts > 0) {
      attempts -= 1
      const res = await apiCall()
      const body = await res.json()

      if (res.ok) {
        resBody = body
        break
      } else if (body.error?.code === IG_RATE_LIMIT_EXCEEDED_ERR_CODE) {
        throw new Error('Try again later')
      } else {
        if (attempts === 0) {
          throw new Error('Try again later')
        }

        continue
      }
    }

    const { paging, data } = resBody
    const items = data.filter(
      ({ media_type }: any) =>
        media_type === 'IMAGE' || media_type === 'CAROUSEL_ALBUM'
    )
    const itemWithSbIds = attachSbIdsToIgPosts(items)

    return { items: itemWithSbIds, paging }
  }

  // current ig api doesn't provide direct way to check for private accounts
  // we try to get the first post image, if we can't load it then most likely it is a private account
  const handleCheckIgPrivateAccount = async (items: any) => {
    if (items.length > 0) {
      try {
        await axios.get(
          `/api/v1/ig?igUrl=${encodeURIComponent(
            items[0].permalink + 'media/?size=l'
          )}`
        )
        setIsIgPrivate(false)
      } catch (err) {
        if (err.response?.status === 400) {
          // error indicates that the account is private
          setIsIgPrivate(true)
        }
      }
    }
  }

  const fetchIgPosts = async (userId: number, accessToken: string) => {
    setLoading(true)
    setIgErr('')

    let items
    let paging

    try {
      const res = await handleGetIgPosts(
        `https://graph.instagram.com/me/media?fields=id,username,media_url,permalink,media_type&access_token=${accessToken}&limit=100`
      )
      items = res.items
      paging = res.paging
    } catch (err) {
      setIgErr('Something went wrong, please try again later.')
      return
    }

    await handleCheckIgPrivateAccount(items)

    // initial ig items
    const instagramInfo = {
      total: items.length,
      userId,
      items,
    }
    dispatch({
      type: 'UPDATE_INSTAGRAM_INFOMATION',
      instagramInfo,
    })
    setLoading(false)
    setIsModalIg(true)
    setIsFetchingIgPosts(false)

    // if initial item less than the required number to show container scroll
    // then we keep fetching until we meet this number or consume all user ig posts
    const MINIMUM_SHOWED_POSTS = 13
    let nextUrl = paging?.next
    while (instagramInfo.total < MINIMUM_SHOWED_POSTS && nextUrl) {
      try {
        const { items: nextItems, paging: nextPaging } = await handleGetIgPosts(
          nextUrl
        )
        nextUrl = nextPaging?.next

        instagramInfo.items = [...instagramInfo.items, ...nextItems]
        instagramInfo.total = instagramInfo.items.length

        dispatch({
          type: 'UPDATE_INSTAGRAM_INFOMATION',
          instagramInfo,
        })
      } catch (err) {
        setIgErr('Unable to fetch more posts, please try again later.')
        return
      }
    }

    setIgNextProducts(nextUrl)
    setIsFetchingIgPosts(false)
  }

  const onScrollLoadMore = async () => {
    if (igNextProducts) {
      let items
      let paging

      try {
        const res = await handleGetIgPosts(igNextProducts)
        items = res.items
        paging = res.paging
      } catch (err) {
        setIgErr('Unable to fetch more posts, please try again later.')
        return
      }

      const igItems = [...appState.instagramInfo.items, ...items]
      const instagramInfo = {
        items: igItems,
        total: igItems.length,
      }

      dispatch({
        type: 'UPDATE_INSTAGRAM_INFOMATION',
        instagramInfo,
        userId: appState.instagramInfo.userId,
      })
      setIgNextProducts(paging?.next)
      setIsFetchingIgPosts(false)
    }
  }

  useEffect(() => {
    ;(async () => {
      if (redirectCode) {
        window.history.pushState('', '', '?')
        setLoading(true)

        let accessToken
        let userId

        try {
          const res = await axios.post(
            '/api/v1/shopping-boards/verify-instagram',
            {
              code: redirectCode,
            }
          )
          accessToken = res.data.data.accessToken
          userId = res.data.data.userId
        } catch (err) {
          setLoading(false)
          return
        }

        if (accessToken) {
          setItemToLocalStorage(
            'ig_token',
            JSON.stringify({ accessToken, userId, timestamp: Date.now() })
          )

          return fetchIgPosts(userId, accessToken)
        }
      }
    })()
  }, [])

  const handleOpenInstaAuthWindow = () => {
    const clientId = process.env.GATSBY_IG_CLIENT_ID
    const redirectUri = process.env.GATSBY_IG_REDIRECT_URI
    window.location.href = `https://api.instagram.com/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&scope=instagram_business_basic&response_type=code`
  }

  const createFolderCloseModal = value => {
    return handleCreateFolder(value).then(() => setIsFolderModal(false))
  }

  const [sentryRef, { rootRef }] = useInfiniteScroll({
    loading: isFetchingIgPosts,
    hasNextPage: Boolean(igNextProducts),
    onLoadMore: onScrollLoadMore,
    disabled: Boolean(igErr),
    rootMargin: '0px 0px 0px 0px',
  })

  const handleAddFromInstagram = async () => {
    const igToken = JSON.parse(window.localStorage.getItem('ig_token'))
    const isIgTokenExpired =
      igToken && (igToken.timestamp || 0) + 3600000 < Date.now()
    if (igToken && !isIgTokenExpired) {
      try {
        await fetchIgPosts(igToken.userId, igToken.accessToken)
      } catch (err) {
        // most likely the token has expired, lets get a new one
        handleOpenInstaAuthWindow()
      }
    } else {
      handleOpenInstaAuthWindow()
    }
  }

  return (
    <>
      {loading && (
        <div className={classes.loading}>
          <CircularProgress style={{ color: COLORS.black }} size={40} />
        </div>
      )}
      <article className={classes.profileWrapper}>
        <ContentContainer>
          {!isSmallScreen ? (
            <div className={classes.breadcrumb}>
              <Breadcrumbs aria-label="breadcrumb">
                <Links
                  color="inherit"
                  rel="preconnect"
                  onClick={(
                    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
                  ) => {
                    event.preventDefault()
                    navigate(ROUTES.home)
                  }}
                >
                  home
                </Links>
                <Links
                  color="inherit"
                  rel="preconnect"
                  onClick={(
                    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
                  ) => {
                    event.preventDefault()
                    navigate(ROUTES.theChirpyest)
                  }}
                >
                  chirpyest community
                </Links>
                <Typography color="textPrimary">
                  {(
                    shoppingUserProfile.username ||
                    shoppingUserProfile.fullName ||
                    ''
                  ).toLowerCase()}
                  's shopping board
                </Typography>
              </Breadcrumbs>
            </div>
          ) : null}
        </ContentContainer>

        <ContentContainer customStyle={classes.profileInner}>
          <section className={classes.personalInfo}>
            {canEdit && !shoppingUserProfile.imageUrl ? (
              <label
                className={classes.avatarCircle}
                htmlFor="upload-dashboard-avatar"
                title="Change Profile Image"
              >
                <CHRUploadAvatar
                  inputId="upload-image-settings-tab"
                  circleInputId="upload-dashboard-avatar"
                  shoppingUserProfile={shoppingUserProfile}
                  updateShoppingProfile={updateShoppingProfile}
                  canEdit={canEdit}
                />
              </label>
            ) : (
              <div className={classes.avatarCircle}>
                <CHRUploadAvatar
                  inputId="upload-image-settings-tab"
                  shoppingUserProfile={shoppingUserProfile}
                  canEdit={canEdit}
                />
              </div>
            )}
            <div className={classes.rightInfo}>
              <Typography
                variant="h1"
                component="h2"
                classes={{ h1: classes.userName }}
              >
                {shoppingUserProfile && (
                  <>
                    {truncateUserName(shoppingUserProfile.username) ||
                      truncateUserName(shoppingUserProfile.fullName)}
                  </>
                )}
              </Typography>
              <div className={classes.profileBioWrapper}>
                <div className={classes.profileExternalLinks}>
                  {canEdit ? (
                    <div className={classes.editingBio}>
                      <div
                        ref={bioDisplayRef}
                        className={`${classes.shortText} ${bioClampClass} ${
                          isEditingBio ? classes.shortTexthHide : ''
                        }`}
                      >
                        {displayShortBio}
                      </div>
                    </div>
                  ) : (
                    <Typography
                      component="div"
                      variant="subtitle1"
                      ref={bioDisplayRef}
                      className={`${classes.profileBio} ${bioClampClass}`}
                    >
                      {displayShortBio}
                    </Typography>
                  )}

                  {isBioToggleBtnVisible && displayShortBio && (
                    <button
                      className={classes.toggleBioBtn}
                      onClick={() => setIsBioOpen(!isBioOpen)}
                    >
                      {isBioOpen ? 'show less' : 'show more'}
                    </button>
                  )}

                  <div
                    className={`${classes.shortText}`}
                    style={{ fontSize: 14 }}
                  >
                    <Anchor
                      className={classes.blogLink}
                      href={
                        blogLink?.match(/^http[s]*:\/\/[\w]+/i)
                          ? blogLink
                          : `http://${blogLink}`
                      }
                    >
                      {blogLink}
                    </Anchor>
                  </div>
                  {hasProfileSocialIcons && (
                    <div className={classes.profileExternalLinksWrapper}>
                      <div className={classes.profileSocialLinks}>
                        {profileExternalLinks.map(link => {
                          const platform = getProfileSocialPlatform(
                            link.platform
                          )
                          return renderProfileSocialIcon(
                            `${link.platform}-${link.url}`,
                            link.url,
                            platform.label,
                            platform.profileLogo || platform.logo
                          )
                        })}
                      </div>
                    </div>
                  )}
                </div>
                {canEdit && (
                  <div className={classes.socialLinksRow}>
                    <button
                      type="button"
                      className={classes.addSocialLinksBtn}
                      onClick={() => setIsProfileModalOpen(true)}
                      title={t('shoppingBoard.profileUpdateTitle')}
                      aria-label={t('shoppingBoard.profileUpdateTitle')}
                    >
                      <img src={editIcon} alt="" />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </section>

          <section
            className={`${classes.profileActions} ${!canEdit &&
              classes.sortOptionsWrapper}`}
          >
            {canEdit && (
              <CHRButton
                label={t('shoppingBoard.addItemToBoard')}
                onClick={addItemToShoppingBoard}
                customStyle={classes.btn}
                hoverEffects={true}
              />
            )}
            {canEdit &&
              (!folderView ||
              !(
                appState.userProfile.isPro || appState.userProfile.isCreator
              ) ? null : ( // for now null
                <CHRButton
                  label={t('shoppingBoard.createNewFolder')}
                  onClick={handleCreateNewFolderClick} // TODO : open create folder modal
                  customStyle={classes.btn}
                  hoverEffects={true}
                />
              ))}
            {canEdit &&
              (!folderView || isTablet ? (
                <CHRButton
                  icon={uploadIcon}
                  iconHover={uploadIconHover}
                  label={t('shoppingBoard.shareShoppingBoard')}
                  onClick={handleCreateShareLinkClick}
                  customStyle={`${classes.btn} ${classes.btnOther}`}
                  hoverEffects={true}
                />
              ) : (
                <div
                  className={classes.shareBtnWraapper}
                  onClick={handleCreateShareLinkClick}
                >
                  <img src={uploadIcon} alt="share icon" />
                </div>
              ))}

            <Box className={classes.sortContainer}>
              <Box>
                {canEdit && (
                  <SBSort
                    options={options}
                    selectedItem={selectedSort}
                    onSortChange={onSortChange}
                  />
                )}
                {!canEdit && (
                  <SBSort
                    options={nonUserOptions}
                    selectedItem={selectedSort}
                    onSortChange={onSortChange}
                  />
                )}
              </Box>

              {folderView && (
                <TextField
                  label="search folder"
                  inputProps={{
                    className: classes.searchField,
                  }}
                  InputLabelProps={{
                    className: classes.searchFieldLabel,
                  }}
                  value={searchQuery || ''}
                  onChange={e => handleSearchQueryChange(e.target.value)}
                />
              )}
            </Box>
          </section>
        </ContentContainer>

        <ShareShoppingBoardModal
          handleClose={closeModal}
          openStatus={isModal}
          shareUrl={shareUrl}
        />

        <CreateNewFolderModal
          handleClose={closeCreateNewFolderModal}
          openStatus={isFolderModal}
          shareUrl={shareUrl}
          handleCreateFolder={createFolderCloseModal}
        />

        <AddFromInstagramModal
          handleClose={closeModalIg}
          openStatus={isModalIg}
          isIgPrivate={isIgPrivate}
          loading={isFetchingIgPosts}
          error={igErr}
          handleSBoardItemsChange={handleSBoardItemsChange}
          rootRef={rootRef}
          sentryRef={sentryRef}
          hasNextPage={Boolean(igNextProducts)}
          shoppingBoardItems={shoppingBoardItems}
          handleOpenInstaAuthWindow={handleOpenInstaAuthWindow}
          handleSwitchAccount={() => {
            setIsSwitchModalOpen(true)
            closeModalIg()
          }}
        />

        <ConnectInstagramModal
          handleClose={() => setInstaModal(false)}
          openStatus={instaModal}
          socialUrls={
            parseJsonField<Record<string, string>>(
              shoppingUserProfileInit.socialUrls
            ) || {}
          }
          userId={shoppingUserProfileInit.id}
          handleAfterConnect={(url: string) => {
            setInstagramUrl(url)
            setInstaModal(false)
            handleOpenInstaAuthWindow()
          }}
        />

        <SwitchAccountsModal
          openStatus={isSwitchModalOpen}
          handleClose={() => setIsSwitchModalOpen(false)}
        />

        <ManageProfileModal
          openStatus={isProfileModalOpen}
          handleClose={() => setIsProfileModalOpen(false)}
          initialShortBio={shoppingUserProfile?.shortBio || ''}
          initialBlogLink={shoppingUserProfile?.blogLink || ''}
          initialLinks={profileExternalLinks}
          onSubmit={updateProfileFromModal}
        />
      </article>
    </>
  )
}
export default withTranslation()(BoardProfile)
